import { createApp } from 'vue';
import HikeMapEmbed from './HikeMapEmbed.vue';

if (document.querySelector('#hike-map-embed')) {
  const app = createApp(HikeMapEmbed);
  app.mount('#hike-map-embed');
}
